import { render, staticRenderFns } from "./FullScreen.vue?vue&type=template&id=c673767c&scoped=true&"
import script from "./FullScreen.vue?vue&type=script&lang=js&"
export * from "./FullScreen.vue?vue&type=script&lang=js&"
import style0 from "./FullScreen.vue?vue&type=style&index=0&id=c673767c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c673767c",
  null
  
)

export default component.exports